(() => {
  if(customElements.get('mint-city'))return;
  customElements.define('mint-city',class extends HTMLElement {
    connectedCallback(){
      if(this.abort&&!this.abort.signal.aborted)return;
      this.abort=new AbortController();
      this.canvas=this.querySelector('[data-city-paint]');this.print=this.querySelector('[data-city-print]');
      const nodes=Array.from(this.querySelectorAll('[data-city-source]'));
      this.sources=nodes.map(node=>node.dataset.citySource);
      this.sourceSets=nodes.map(node=>({srcset:node.dataset.citySrcset,sizes:node.dataset.citySizes}));
      this.regionURL=this.querySelector('[data-city-regions]')?.dataset.cityRegions;
      this.context=this.canvas?.getContext('2d');
      if(!this.context||!this.sources.length||!globalThis.ManhattanWatercolor){this.showPrint();return;}
      this.images=[];this.pending=new Map();this.regionImage=null;this.regionPending=null;this.regionReady=!this.regionURL;
      this.index=0;this.elapsed=0;this.lastTick=null;this.lastDraw=null;this.preparedIndex=null;this.painter=null;
      this.paintEnd=18000;this.exitStart=21000;this.cycle=27000;this.width=384;this.height=216;
      this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.inView=typeof IntersectionObserver!=='function';
      const on=(node,type,fn)=>node.addEventListener(type,fn,{signal:this.abort.signal});
      on(this.reduced,'change',()=>this.refresh());on(document,'visibilitychange',()=>this.refresh());
      if(navigator.connection?.addEventListener)on(navigator.connection,'change',()=>this.refresh());
      if(typeof IntersectionObserver==='function'){
        this.observer=new IntersectionObserver(entries=>{this.inView=entries.some(entry=>entry.isIntersecting);this.refresh();},{threshold:0});this.observer.observe(this);
      }
      this.classList.add('is-loading');const signal=this.abort.signal;
      this.load(0).then(image=>{if(signal.aborted)return;if(image)this.refresh();else this.showPrint();});this.refresh();
    }
    load(index){
      if(this.images[index])return Promise.resolve(this.images[index]);
      if(this.pending.has(index))return this.pending.get(index);
      const signal=this.abort.signal;
      const promise=new Promise(resolve=>{
        const image=new Image();image.crossOrigin='anonymous';image.fetchPriority=index===0?'high':'low';
        image.onload=()=>{if(!signal.aborted)this.images[index]=image;resolve(signal.aborted?null:image);};image.onerror=()=>resolve(null);
        if(this.sourceSets[index]?.srcset){image.sizes=this.sourceSets[index].sizes;image.srcset=this.sourceSets[index].srcset;}
        image.src=this.sources[index];
      });this.pending.set(index,promise);return promise;
    }
    loadRegions(){
      if(this.regionReady||this.regionPending)return;
      const signal=this.abort.signal;
      const image=new Image();image.crossOrigin='anonymous';image.fetchPriority='low';this.regionPending=image;
      const finish=loaded=>{if(signal.aborted)return;this.regionImage=loaded?image:null;this.regionReady=true;this.refresh();};
      image.onload=()=>finish(true);image.onerror=()=>finish(false);image.src=this.regionURL;
    }
    canAnimate(){return !this.abort.signal.aborted&&!this.reduced.matches&&!navigator.connection?.saveData&&this.inView&&!document.hidden;}
    showPrint(){this.classList.remove('is-loading','is-playing');if(this.canvas)this.canvas.hidden=true;}
    refresh(){
      if(this.abort.signal.aborted)return;
      cancelAnimationFrame(this.frame);this.frame=null;this.lastTick=null;
      if(this.reduced.matches||navigator.connection?.saveData){this.showPrint();return;}
      if(!this.images[this.index]||!this.canAnimate())return;
      if(this.index===0&&!this.regionReady){this.loadRegions();return;}
      if(this.preparedIndex!==this.index&&!this.prepare(this.index)){this.showPrint();return;}
      this.canvas.hidden=false;this.classList.remove('is-loading');this.classList.add('is-playing');
      this.draw(this.elapsed);this.load((this.index+1)%this.sources.length);this.frame=requestAnimationFrame(time=>this.tick(time));
    }
    prepare(index){
      try{this.painter=ManhattanWatercolor.createPainter(this.canvas,this.images[index],{regionImage:index===0?this.regionImage:null,scene:index,width:this.width,height:this.height});
        this.passes=this.painter.glazes;this.preparedIndex=index;this.canvas.dataset.scene=String(index+1);this.canvas.dataset.layers=String(this.passes.length);return true;
      }catch{return false;}
    }
    tick(time){
      if(!this.canAnimate()){this.lastTick=null;return;}
      if(this.lastTick!=null)this.elapsed+=Math.min(250,Math.max(0,time-this.lastTick));this.lastTick=time;
      if(this.elapsed>=this.cycle){
        const next=(this.index+1)%this.sources.length;
        if(!this.images[next]){this.draw(this.paintEnd);this.frame=null;const signal=this.abort.signal;this.load(next).then(image=>{if(!signal.aborted&&image)this.refresh();});return;}
        this.elapsed%=this.cycle;this.index=next;
        if(!this.prepare(next)){this.showPrint();return;}
        this.load((next+1)%this.sources.length);
      }
      if(this.lastDraw==null||time-this.lastDraw>=30){this.draw(this.elapsed);this.lastDraw=time;}
      this.frame=requestAnimationFrame(nextTime=>this.tick(nextTime));
    }
    draw(elapsed){
      const transitioning=elapsed>this.exitStart&&!!this.images[(this.index+1)%this.sources.length];
      this.canvas.dataset.phase=transitioning?'blend':elapsed>=this.paintEnd?'hold':'glaze';
      this.canvas.dataset.time=String(Math.round(elapsed));
      const t=Math.max(0,Math.min(1,(elapsed-this.exitStart)/(this.cycle-this.exitStart)));
      const opacity=transitioning?1-t*t*(3-2*t):1;
      this.painter.draw(Math.min(this.paintEnd,elapsed)/1000,opacity);
    }
    disconnectedCallback(){
      this.abort?.abort();this.observer?.disconnect();cancelAnimationFrame(this.frame);this.frame=null;this.lastTick=null;this.painter=null;this.showPrint();
    }
  });
})();
